import React, { useState } from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";

const CollapsibleSection = ({ title, children, defaultOpen = true }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="screenDetail__section">
      <div className="screenDetail__section-head">
        <h3 className="screenDetail__section-title">{title}</h3>
        <button type="button" className="screenDetail__toggle" onClick={() => setOpen(!open)}>
          {open ? t("Hide") : t("Show")} <Icon type={open ? "up" : "down"} />
        </button>
      </div>
      {open && <div className="screenDetail__section-body">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
